// extracted by mini-css-extract-plugin
module.exports = {"textInputWrapper":"_c2a8dd3a","animatedPlaceholderPadding":"_5138e60f"};